import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/domains/users/models';
import { UsersService } from 'src/app/domains/users/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-edit-user-popup',
  templateUrl: './edit-user-popup.component.html',
  styleUrls: ['./edit-user-popup.component.scss']
})
export class EditUserPopupComponent {
  public user: User;
  public companyId: number;
  public loading: boolean = false;
  @Output() onEditUser: EventEmitter<any> = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal, private usersService: UsersService, private notification: NotificationService) {}

  editUser(event) {
    this.loading = true;
    if(this.user._isEditing) {
      this.usersService.editUser(this.companyId, event,
        [
          {
            status: 400,
            message: 'company.user.edit-popup.error'
          }
        ])
      .subscribe((res: any) => {
        this.onEditUser.emit();
        this.loading = false;
        this.close();
      }, () => {
        this.close();
      });
    }
  }

  close() {
    this.activeModal.close();
  }
}
